/**
 * @generated SignedSource<<62c76f6fe3731e4ce004a1677ac1368a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAllowCustomQuote_deliveryOptions$data = ReadonlyArray<{
  readonly isLocalPickup: boolean | null;
  readonly showQuoteAsPending: boolean | null;
  readonly " $fragmentType": "CheckoutAllowCustomQuote_deliveryOptions";
}>;
export type CheckoutAllowCustomQuote_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutAllowCustomQuote_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAllowCustomQuote_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutAllowCustomQuote_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocalPickup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "725d8fc142b4311bd6df9020d44febc8";

export default node;
